<template>
  <div class="pc-dialog" v-if="visible && isPC" @click='hideDialog(true)'>
    <div class="select-model" @click.stop='hideDialog(false)'>
      <div>
        <div class="select-title">请选择登录身份</div>
        <div class="select-box">
          <div class="select-list" :class="{ list: roleIndex != index, 'list-active': roleIndex == index }" v-for="(item, index) in roleList" :key="index" @click="roleSelect(index)">
            <span> {{ item.typeName }}（{{ item.userId }}） </span>
          </div>
          <div id='roleErrorTips' style="color:red; margin-top:10px"></div>
        </div>
      </div>
      <div class="select-btn">
        <el-button size="large" type="primary" @click="webSelectSubmit" :loading="loading" class="login-button">确定
        </el-button>
      </div>
    </div>
  </div>
  <!-- app选择身份 -->
  <div class="app-dialog" v-else-if="visible && !isPC" @click='hideDialog(true)'>
    <div class="select-model" @click.stop='hideDialog(false)'>
      <div>
        <div class="select-title">请选择登录账号</div>
        <div class="select-box">
          <div class="select-list" v-for="(item, index) in roleList" :key="index" @click="roleSelect(index)">
            <div class="select-left">
              <span>
                {{ item.typeName }}
              </span>
              <span> （{{ item.userId }}） </span>
            </div>
            <div class="select-right" v-if="index == roleIndex">
              <img src="../../../../assets/select.png" alt="" />
            </div>
          </div>
          <div id='roleErrorTips' style="color:red; margin-top:10px"></div>
        </div>
      </div>
      <div class="select-btn">
        <el-button size="large" type="primary" :loading="loading" @click="webSelectSubmit" class="login-button">确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    isPC: Boolean,
    loading: Boolean,
    roleList: Array,
  },
  data () {
    return {
      roleIndex: -1, // 身份
    }
  },
  methods: {
    // web选择身份
    roleSelect (index) {
      this.roleIndex = index
    },
    hideDialog (value) {
      console.log('hideDialog: value = ', value);
      if (!value) {
        return;
      }
      this.$emit("hideDialog", true);
    },
    webSelectSubmit () {
      console.log(`this.roleIndex = ${this.roleIndex}`);
      let errorTips = document.getElementById("roleErrorTips");
      errorTips.innerHTML = "";
      if (this.roleIndex >= 0 && this.roleIndex < this.roleList.length) {
        this.$emit("webSelectSubmit", this.roleList[this.roleIndex].userId);
      } else {
        errorTips.innerHTML = "请选择登录身份！"
        setTimeout(function () {
          errorTips.innerHTML = ""
        }, 3000)
      }
    },
  },
}
</script>
<style lang="less" scoped>
// 选择身份
.pc-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2013;
  background: rgba(0, 0, 0, 0.5);
  .select-model {
    width: 532px;
    height: 354px;
    box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px 32px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .select-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202020;
      line-height: 22px;
    }

    .select-box {
      padding-top: 2px;

      .select-list {
        padding: 7px 12px;
        border-radius: 4px;
        margin-top: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 26px;
        cursor: pointer;
      }
      .list {
        border: 1px solid #d9d9d9;
        color: #666666;
      }
      .list-active {
        border: 1px solid #4086f6;
        color: #4086f6;
      }
    }

    .select-btn {
      // position: absolute;
      bottom: 16px;
      width: 100%;
      text-align: center;

      button {
        padding: 3px 26px;
        background: #4086f6;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 26px;
      }
    }
  }
}

// app选择身份
.app-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2013;
  background: rgba(0, 0, 0, 0.5);

  .select-model {
    width: 100%;
    height: 375px;
    box-sizing: border-box;
    padding: 16px;
    background: #fff;
    border-radius: 16px 16px 0 0;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .select-title {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202020;
      line-height: 22.5px;
    }

    .select-box {
      padding-top: 2px;

      .select-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;

        &:not(:last-child) {
          border-bottom: 1px solid #eaeaea;
        }

        .select-left {
          span {
            &:nth-child(1) {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #202020;
              line-height: 21px;
            }

            &:nth-child(2) {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 21px;
            }
          }
        }

        .select-right {
          width: 18px;
          height: 18px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .select-btn {
      // position: absolute;
      bottom: 16px;
      width: 100%;

      button {
        width: 100%;
        background: #4086f6;
        border: none;
        border-radius: 20px;
      }
    }
  }
}
</style>
